export interface swipeParams {

    swipeThreshold?: number,
    thresholdReachedCallback?: (element: HTMLElement) => {},
    autoReverseItemBack?: boolean,
    forceCallbackBeforeTouchEnd?: boolean,

}

const defaultSwipeParams = {

    swipeThreshold: 100,
    autoReverseItemBack: true,
    forceCallbackBeforeTouchEnd: false,

} as swipeParams

export default {


    mounted(el, binding) {

        let startX, startY, nowX, nowY
        let active = false
        let touchTimeStart

        let direction

        let elSateAtStart: any = {}

        const timers = {
            longTap: null,
        }


        const clearElementStyles = () => {

            for (const prop in elSateAtStart)
                if (elSateAtStart[prop]) {
                    el.style[prop] = elSateAtStart[prop]
                } else {
                    el.style.removeProperty(prop)
                }

        }

        const swipeThresholdReached = () => {

            if (!direction)
                return false

            const difx = Math.abs(nowX - startX)
            const dify = Math.abs(nowY - startY)

            const params = binding.value ? binding.value as swipeParams : defaultSwipeParams

            if (direction === 'x' && (binding.modifiers?.left || binding.modifiers?.right)) {
                return difx >= params.swipeThreshold
            } else if (direction === 'y' && (binding.modifiers?.top || binding.modifiers?.bottom)) {
                return dify >= params.swipeThreshold
            }

        }

        el.addEventListener('touchstart', async (event) => {

            if (event.touches.length !== 1)
                return;


            active = true
            touchTimeStart = new Date()

            startX = event.touches[0].screenX
            startY = event.touches[0].screenY

            if (binding.arg === 'drag') {
                el.style.position = 'relative'
            }

            if (binding.arg === 'swipe') {

                elSateAtStart = {
                    transition: el.style.transition,
                    position: el.style.position,
                    left: el.style.left,
                    top: el.style.top,
                }
                el.classList.add('in-swipe-mode')

                el.style.position = 'relative'
                el.style.transition = 'all 0ms'
                direction = null
            }

            if (binding.arg === 'longTap') {
                timers.longTap = setTimeout(() => {

                    if (binding.value)
                        binding.value({
                            element: el,
                            duration: 300,
                        })

                }, 300);
            }


        }, {passive: true})

        el.addEventListener('touchmove', async (event) => {

            if (event.touches.length !== 1 || !active)
                return;

            nowX = event.touches[0].screenX
            nowY = event.touches[0].screenY

            if (binding.arg === 'drag') {

                const difx = Math.abs(event.touches[0].screenX - startX)
                const dify = Math.abs(event.touches[0].screenY - startY)

                if (!direction)
                    direction = difx > dify ? 'x' : 'y'

                if (binding.modifiers?.top && event.touches[0].screenY < startY)
                    el.style.top = `${event.touches[0].screenY - startY}px`

                if (binding.modifiers?.bottom && event.touches[0].screenY > startY)
                    el.style.top = `${event.touches[0].screenY + startY}px`

                if (binding.modifiers?.left && event.touches[0].screenX < startX)
                    el.style.left = `${event.touches[0].screenX - startX}px`

                if (binding.modifiers?.right && event.touches[0].screenX > startX)
                    el.style.left = `${event.touches[0].screenX - startX}px`

            }

            if (binding.arg === 'swipe') {


                const params = binding.value ? binding.value as swipeParams : defaultSwipeParams

                const difx = Math.abs(event.touches[0].screenX - startX)
                const dify = Math.abs(event.touches[0].screenY - startY)

                if (!direction)
                    direction = difx > dify ? 'x' : 'y'

                if (!swipeThresholdReached()) {

                    if (binding.modifiers?.left && event.touches[0].screenX < startX)
                        el.style.left = `${event.touches[0].screenX - startX}px`

                    if (binding.modifiers?.right && event.touches[0].screenX > startX)
                        el.style.left = `${event.touches[0].screenX - startX}px`

                    if (binding.modifiers?.top && event.touches[0].screenY < startY)
                        el.style.top = `${event.touches[0].screenY - startY}px`

                    if (binding.modifiers?.bottom && event.touches[0].screenY > startY)
                        el.style.top = `${event.touches[0].screenY + startY}px`

                } else {

                    if (params.forceCallbackBeforeTouchEnd) {

                        active = false

                        if (params.thresholdReachedCallback)
                            await params.thresholdReachedCallback(el)

                        clearElementStyles()

                    }

                }


            }

        }, {passive: true})

        el.addEventListener('touchend', async (event) => {

            if (!active)
                return;

            active = false

            el.classList.remove('in-swipe-mode')

            const now_time = new Date()
            const touchDuration = ((now_time.getTime() - touchTimeStart.getTime()))
            const xDif = startX - event?.changedTouches[0].screenX
            const yDif = startY - event?.changedTouches[0].screenY

            touchTimeStart = null

            if (binding.arg === 'tap' && touchDuration < 100) {

                if (binding.value)
                    binding.value({
                        element: el,
                        duration: touchDuration,
                    })

                return
            }

            if (binding.arg === 'longTap') {
                clearTimeout(timers.longTap);
                return
            }

            if (binding.arg === 'drag' && binding.value) {

                binding.value({
                    moveDif: event?.changedTouches[0].screenY - startY,
                    startPosition: {
                        x: startX,
                        y: startY,
                    },
                    endPosition: {
                        x: event?.changedTouches[0].screenX,
                        y: event?.changedTouches[0].screenY,
                    }
                })

            }
            if (binding.arg === 'swipe' && binding.value) {


                const params = binding.value ? binding.value as swipeParams : defaultSwipeParams

                if (swipeThresholdReached()) {

                    if (params.thresholdReachedCallback)
                        await params.thresholdReachedCallback(el)

                    clearElementStyles()

                } else if (params.autoReverseItemBack) {

                    el.style.transition = 'all 200ms'
                    el.style.left = elSateAtStart.left ?? '0'
                    el.style.top = elSateAtStart.top ?? '0'
                    setTimeout(() => {
                        clearElementStyles()
                    }, 200)

                }

            }


        }, {passive: true})


    }

}